import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const RebootIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M19.95,8.97C19.37,3.47,14.44-.52,8.94.06c-2.54.26-4.88,1.48-6.55,3.4l-.15-1.37L.04,2.33l.63,5.57,5.59-.53-.21-2.19-2.38.22c1.31-1.77,3.31-2.91,5.5-3.13,4.29-.44,8.15,2.67,8.59,6.94.44,4.28-2.68,8.11-6.97,8.55,0,0,0,0,0,0-4.29.44-8.15-2.67-8.59-6.94L0,11.04c.54,5.09,4.84,8.96,9.96,8.96.35,0,.7-.02,1.06-.05,5.5-.56,9.5-5.47,8.94-10.97,0,0,0,0,0,0Z" />
 </svg>,
 "Reboot"
);
